import { type ReactNode } from "react";
import { Camera, Scale, Undo2 } from "lucide-react";

interface Props {
  onReceipt: () => void;
  onSettle: () => void;
  onUndo: () => void;
}

interface ActionButtonProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
}

function ActionButton({ icon, label, onClick }: ActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex flex-col items-center gap-1.5 flex-1 py-4 bg-surface border border-hairline rounded-xl shadow-card active:bg-surface-2 active:scale-95 transition-all"
    >
      <span className="text-fg">{icon}</span>
      <span className="font-sans text-xs font-medium text-muted">{label}</span>
    </button>
  );
}

export default function ActionRow({ onReceipt, onSettle, onUndo }: Props) {
  return (
    <div className="flex gap-2.5">
      <ActionButton icon={<Camera size={20} />} label="Receipt" onClick={onReceipt} />
      <ActionButton icon={<Scale size={20} />} label="Settle" onClick={onSettle} />
      <ActionButton icon={<Undo2 size={20} />} label="Undo" onClick={onUndo} />
    </div>
  );
}
